import React,{Component} from 'react';
import "./css/newsapp.css";

export default class News extends Component{
  constructor(){
    super();
    this.state={
      newsdata:[],
      filterednewsdata:[]
    }
  }

  componentDidMount(){

    fetch("https://api.nytimes.com/svc/mostpopular/v2/viewed/7.json?api-key=yAcV8vN2FIttVjHtNHhUuV6e6QclBeY4")
    .then(response=>response.json())
    .then((data)=>{
      this.setState({newsdata:data.results})
      this.setState({filterednewsdata:data.results})
      console.log(this.state.filterednewsdata)
      // console.log(data.results[0].media[0]["media-metadata"][2].url)
    })
    .catch((err)=> {
      console.log(err);
    })
  }
  readInputValue=(value)=>{
    let tempNews=this.state.newsdata.filter((n)=>{
      return(
        n.adx_keywords.toLowerCase().includes(value.toLowerCase()));
      })
      this.setState({filterednewsdata:tempNews});
  }

  render(){
    return(
      <div className='news-container'>
        
        <h1>News by New York Times Api</h1>
        <input className='search' placeholder="Search by Keywords" onChange={(event)=>{this.readInputValue(event.target.value)}}/>
        <div className='news-cards'>
        { this.state.filterednewsdata.map((n,index)=>(

                <div className='card' key={index}>
                <img src={(n.media.length!==0)?n.media[0]["media-metadata"][1].url:null} alt={(n.media.length!==0)?n.media[0].caption:'NoImage'}/>


                  <div className="cardbody">
                    <h3>{n.title}</h3>
                    <p>{n.abstract} <br/>
                    <small><em> {n.byline} <br/>{n.published_date}</em> </small>
                    </p>
                    <a href={n.url}>click here to read more</a>
                  </div>
                </div>

            ))
          }
        </div>
      </div>
    )
  }
}
